export default __webpack_public_path__ + "static/media/avatar-male-user.6312d5be.svg";